import styles from './_colour.module.scss';

export const darkTheme = {
  token: {
    colorBorder: styles['primaryPurple'],
    colorBgContainer: styles['black'],
    colorBgElevated: styles['black'],
    colorBgLayout: styles['black'],
    colorTextPlaceholder: styles['liteGrey'],
    colorText: styles['white'],
    colorPrimary: styles['deepTeal'],
    colorPrimaryHover: styles['primaryPurple'],
    colorBgContainerDisabled: styles['primaryPurple'],
  },
  components: {
    Layout: {
      colorBorder: styles['primaryPurple'],
      bodyBg: styles['black'],
      headerBg: styles['black'],
      siderBg: styles['black'],
      triggerBg: styles['black'],
      triggerColor: styles['primaryPurple'],
    },

    Progress: {
      defaultColor: styles['primaryPurple'],
      defaultColor: styles['grey'],
    },
    Timeline: {
      colorSplit: styles['primaryPurple'],
    },
    Switch: {
      colorPrimary: styles['primaryPurple'],
    },

    Steps: {
      colorSplit: styles['white'],
    },

    Menu: {
      itemSelectedBg: 'transparent',
      popupBg: styles['primaryPurple'],
      darkItemSelectedBg: styles['primaryPurple'],
      itemSelectedColor: styles['primaryPurple'],
      horizontalItemSelectedColor: styles['primaryPurple'],
    },
    InputNumber: {
      activeBorderColor: styles['primaryPurple'],
      hoverBorderColor: styles['primaryPurple'],
      activeBg: styles['black'],
      activeShadow: 'transparent',
    },
    Input: {
      colorBgContainerDisabled: styles['none'],
      activeBorderColor: styles['primaryPurple'],
      hoverBorderColor: styles['primaryPurple'],
      activeBg: styles['black'],
      activeShadow: 'transparent',
    },

    Progress: {
      defaultColor: styles['primaryPurple'],
    },
    Collapse: { headerBg: styles['black'] },

    Radio: {
      buttonCheckedBg: styles['primaryPurple'],
      dotSize: 0,
    },
  },
};

export const lightTheme = {
  token: {
    colorBorder: styles['primaryPurple'],
    colorBgContainer: styles['white'],
    colorBgElevated: styles['white'],
    colorBgLayout: styles['white'],
    colorTextPlaceholder: styles['liteGrey'],
    colorText: styles['black'],
    colorPrimary: styles['deepTeal'],
    colorPrimaryHover: styles['primaryPurple'],
    colorBgContainerDisabled: styles['primaryPurple'],
  },
  components: {
    Layout: {
      colorBorder: styles['primaryPurple'],
      bodyBg: styles['white'],
      headerBg: styles['white'],
      siderBg: styles['white'],
      triggerBg: styles['white'],
      triggerColor: styles['primaryPurple'],
    },

    Progress: {
      defaultColor: styles['primaryPurple'],
      defaultColor: styles['grey'],
    },
    Timeline: {
      colorSplit: styles['primaryPurple'],
    },
    Switch: {
      colorPrimary: styles['primaryPurple'],
    },

    Steps: {
      colorSplit: styles['grey'],
    },

    Menu: {
      itemSelectedBg: 'transparent',
      popupBg: styles['primaryPurple'],
      darkItemSelectedBg: styles['primaryPurple'],
      itemSelectedColor: styles['primaryPurple'],
      horizontalItemSelectedColor: styles['primaryPurple'],
    },
    InputNumber: {
      activeBorderColor: styles['primaryPurple'],
      hoverBorderColor: styles['primaryPurple'],
      activeBg: styles['white'],
      activeShadow: 'transparent',
    },
    Input: {
      colorBgContainerDisabled: styles['none'],
      activeBorderColor: styles['primaryPurple'],
      hoverBorderColor: styles['primaryPurple'],
      activeBg: styles['white'],
      activeShadow: 'transparent',
    },

    Progress: {
      defaultColor: styles['primaryPurple'],
    },
    Collapse: { headerBg: styles['white'] },

    Radio: {
      buttonCheckedBg: styles['primaryPurple'],
      dotSize: 0,
    },
  },
};
